import { render } from "./FolderSubfoldersPanel.vue?vue&type=template&id=e6ef4f0e"
import script from "./FolderSubfoldersPanel.vue?vue&type=script&lang=js"
export * from "./FolderSubfoldersPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__